import { TextareaAutosize, useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { BudgetContext } from "../../../../../../../../hooks/ContextStore";
import ActionButton from "../../../../../../../modules/CustomizeComponent/ActionButton";

export default function CreateChildExpense(props) {
  const theme = useTheme();
  const [stats,setStats] = useContext(BudgetContext);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    children,
    handleClose,
    handleClickOpen,
    open,
    client_case_id,
  } = props;

  const school = children
    ? children.filter((pay) => pay.title === "School tuition and supplies")
    : 0;
  const childCare = children
    ? children.filter((pay) => pay.title === "Childcare fees")
    : 0;
  const entertainment = children
    ? children.filter(
        (pay) => pay.title === "Children’s activities and entertainment"
      )
    : 0;
  const insurance = children
    ? children.filter(
        (pay) => pay.title === "Children’s car payment and car insurance"
      )
    : 0;
  const activities = children
    ? children.filter(
        (pay) => pay.title === "Children’s extracurricular activities"
      )
    : 0;
  const babysitting = children
    ? children.filter((pay) => pay.title === "Babysitting")
    : 0;
  const nanny = children
    ? children.filter((pay) => pay.title === "Nanny Expenses")
    : 0;
  const allowances = children
    ? children.filter((pay) => pay.title === "Children’s allowances")
    : 0;
  const [description, setDescription] = useState(null);
  const disable = props.disable;

  const { register, getValues } = useForm({
    mode: "onBlur",
  });



  const handleSubmit = () => {
    formChangedSchool();
    formChangedChildCare();
    formChangedEntertainment();
    formChangedInsurance ();
    formChangedActivities();
    formChangedBaby();
    formChangedNanny();
    formChangedAllowances();
    formChangedDescription();
    handleClose();

  }
  const postMethod = async(data)=>{
    try {
      const response = await Axios
        .post("api/budget/expense", data)
        .catch((err) => {
          if (err && err.response) console.log("Error", err);
        });

      if (response) {
        let firstTimeData = Object(response.data).hasOwnProperty('data');
        let totalOverview = {};
        if(firstTimeData){
          totalOverview = {
            shortfall: response.data.data[0].shortfall,
            total_expenses: response.data.data[0].total_expenses,
            total_gross_income: response.data.data[0].total_gross_income,
            total_net_income: response.data.data[0].total_net_income,
          };
        }else{
          totalOverview = {
            shortfall: response.data.shortfall,
            total_expenses: response.data.total_expenses,
            total_gross_income: response.data.total_gross_income,
            total_net_income: response.data.total_net_income,
          };
        }
        
        setStats(totalOverview);

      }
    } catch (error) {
      if (error.response.status === 500) {
        console.log(error.response.status);
      }
    }
  }



  const formChangedSchool = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "School tuition and supplies",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount !== '' ? formValues.actual_amount : 0,
      projected_amount: formValues.projected_amount !== '' ? formValues.projected_amount : 0,
    };

  postMethod(data);
  };

  const formChangedChildCare = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Childcare fees",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_a !== '' ? formValues.actual_amount_a : 0,
      projected_amount: formValues.projected_amount_a !== '' ? formValues.projected_amount_a : 0,
    };

    postMethod(data);
  };
  const formChangedEntertainment = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Children’s activities and entertainment",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_b !== '' ? formValues.actual_amount_b : 0,
      projected_amount: formValues.projected_amount_b !== '' ? formValues.projected_amount_b : 0,
    };

    postMethod(data);
  };
  const formChangedInsurance = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Children’s car payment and car insurance",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_c !== '' ? formValues.actual_amount_c : 0,
      projected_amount: formValues.projected_amount_c !== '' ? formValues.projected_amount_c : 0,
    };

    postMethod(data);
  };
  const formChangedActivities = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Children’s extracurricular activities",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_d !== '' ? formValues.actual_amount_d : 0,
      projected_amount: formValues.projected_amount_d !== '' ? formValues.projected_amount_d : 0,
    };

    postMethod(data);
  };
  const formChangedBaby = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Babysitting",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_e !== '' ? formValues.actual_amount_e : 0,
      projected_amount: formValues.projected_amount_e !== '' ? formValues.projected_amount_e : 0,
    };

    postMethod(data);
  };
  const formChangedNanny = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Nanny Expenses",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_f !== '' ? formValues.actual_amount_f : 0,
      projected_amount: formValues.projected_amount_f !== '' ? formValues.projected_amount_f : 0,
    };

    postMethod(data);
  };
  const formChangedAllowances = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      title: "Children’s allowances",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_g !== '' ? formValues.actual_amount_g : 0,
      projected_amount: formValues.projected_amount_g !== '' ? formValues.projected_amount_g : 0,
    };

    postMethod(data);
  };

  const formChangedDescription = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-child",
      description: formValues.description,
      client_case_id: client_case_id,
    };

    Axios.post("api/budget/description/store", data)
      .then((res) => {
  
      })
      .catch((err) => {
      });
  };

  const fetchDescription = () => {
    Axios.get(
      "api/budget/description/" + client_case_id + "/" + "monthly-child"
    )
      .then((res) => {
        setDescription(res.data.data);
      })
      .catch((err) => {
        if ((err && "Error", err)) console.log("Error", err.response);
      });
  };



  useEffect(() => {
    fetchDescription();
  }, []);
  
  const numInputs = document.querySelectorAll('input[type=number]')

  numInputs.forEach(function(input) {
    input.addEventListener('change', function(e) {
      if (e.target.value == '') {
        e.target.value = 0;
      }
    })
  })
  
  return (
    <div>
      <ActionButton
        disabled={disable}
        onClick={handleClickOpen}
        type="button"
        className="btn btn-primary"
      >
        Edit/Add
      </ActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        fullScreen={fullScreen}
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Child Related Expenses"}
        </DialogTitle>
        <DialogContent>
          <Row className="mb-4">
            <Col>
              <Form.Label className="form-control border-0">Expense</Form.Label>
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Actual amount
              </Form.Label>
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Projected (future) amount
              </Form.Label>
            </Col>
          </Row>

          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                School tuition and supplies
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={school.length <= 0 ? 0 : school[0].actual_amount}
                {...register("actual_amount", { required: true })}
                // onBlur={formChangedSchool}
              />
            </Col>
            <Col>
              <input
                name="projected_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  school.length <= 0 ? 0 : school[0].projected_amount
                }
                {...register("projected_amount", { required: true })}
                // onBlur={formChangedSchool}
              />
            </Col>
          </Row>

          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Childcare fees
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_a"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  childCare.length <= 0 ? 0 : childCare[0].actual_amount
                }
                {...register("actual_amount_a", { required: true })}
                // onBlur={formChangedChildCare}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_a"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  childCare.length <= 0 ? 0 : childCare[0].projected_amount
                }
                {...register("projected_amount_a", { required: true })}
                // onBlur={formChangedChildCare}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Children’s activities and entertainment
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_b"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  entertainment.length <= 0 ? 0 : entertainment[0].actual_amount
                }
                {...register("actual_amount_b", { required: true })}
                // onBlur={formChangedEntertainment}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_b"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  entertainment.length <= 0
                    ? 0
                    : entertainment[0].projected_amount
                }
                {...register("projected_amount_b", { required: true })}
                // onBlur={formChangedEntertainment}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Children’s car payment and car insurance
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_c"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  insurance.length <= 0 ? 0 : insurance[0].actual_amount
                }
                {...register("actual_amount_c", { required: true })}
                // onBlur={formChangedInsurance}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_c"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  insurance.length <= 0 ? 0 : insurance[0].projected_amount
                }
                {...register("projected_amount_c", { required: true })}
                // onBlur={formChangedInsurance}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Children’s extracurricular activities
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_d"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  activities.length <= 0 ? 0 : activities[0].actual_amount
                }
                {...register("actual_amount_d", { required: true })}
                // onBlur={formChangedActivities}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_d"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  activities.length <= 0 ? 0 : activities[0].projected_amount
                }
                {...register("projected_amount_d", { required: true })}
                // onBlur={formChangedActivities}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Babysitting
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_e"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  babysitting.length <= 0 ? 0 : babysitting[0].actual_amount
                }
                {...register("actual_amount_e", { required: true })}
                // onBlur={formChangedBaby}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_e"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  babysitting.length <= 0 ? 0 : babysitting[0].projected_amount
                }
                {...register("projected_amount_e", { required: true })}
                // onBlur={formChangedBaby}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Nanny Expenses
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_f"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={nanny.length <= 0 ? 0 : nanny[0].actual_amount}
                {...register("actual_amount_f", { required: true })}
                // onBlur={formChangedNanny}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_f"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={nanny.length <= 0 ? 0 : nanny[0].projected_amount}
                {...register("projected_amount_f", { required: true })}
                // onBlur={formChangedNanny}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Children’s allowances
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_g"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  allowances.length <= 0 ? 0 : allowances[0].actual_amount
                }
                {...register("actual_amount_g", { required: true })}
                // onBlur={formChangedAllowances}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_g"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  allowances.length <= 0 ? 0 : allowances[0].projected_amount
                }
                {...register("projected_amount_g", { required: true })}
                // onBlur={formChangedAllowances}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label className="form-control border-0">
                *If you feel that you need to explain any of the above further,
                please use the space below to do so:
              </Form.Label>
              <TextareaAutosize
                className={`form-control`}
                aria-label="minimum height"
                minRows={4}
                name="description"
                type="text"
                defaultValue={description ? description.description : ""}
                {...register("description", { required: true })}
                // onBlur={formChangedDescription}
              />
            </Col>
          </Row>
        </DialogContent>
        <DialogActions>
              <ActionButton
                id="kt_login_signin_submit"
                onClick={handleSubmit}
                className={`btn custom-green-button font-weight-bold px-9 py-4 my-3`}
              >
                <span>Submit</span>
              </ActionButton>
            <Button
              onClick={handleClose}
              className={`btn custom-cancel-button font-weight-bold px-9 py-4 my-3`}
            >
              Cancel
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
